import type { FaireProductEntity } from "../../entity_types/product";

export const p_j3d4gqnsxd: FaireProductEntity = {
  token: "p_j3d4gqnsxd",
  type: "product",
  name: "bouquets paintable watercolor notecard set",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/5bf3f95964248cace6aa3d23ac94d8ba9bcc0721c828be2fe3b3425da88b1a97.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9a3ba493cad04a6c509831e57ccc9e031202225cfd47ad26e6ab76afb63e22b8.jpeg",
    "https://cdn.faire.com/fastly/e058cef0fac64407ea947ec45ea7a8f98db6c016200cf1bcd8212d3dc3ad911b.jpeg",
    "https://cdn.faire.com/fastly/92bd084edfb87d72d1045df25b5455a8a3b181b872fd10fdb63944b8f321ce6b.jpeg",
    "https://cdn.faire.com/fastly/3d7cfd77895e95e03bfabf26dab1b28871042a117fe27538d9215391e0218757.jpeg",
    "https://cdn.faire.com/fastly/6269b0f93967a7ae739e5d06c48dbd9bb438ce653c8d8ae5b7bc42c9614d16a1.jpeg",
    "https://cdn.faire.com/fastly/24fe932fc600a5bc2e55886bb02d29b727e8ebf63b1e4666a81fedc1d43868e0.jpeg",
    "https://cdn.faire.com/fastly/1cbb9b057224f6542fa8574f84a9456cd42e4d295be8547ec1f495888fc57e44.jpeg",
    "https://cdn.faire.com/fastly/c800ce1a83a929eb125791c026dd4b7de031ecfd2b850b653145a26317f5a90a.jpeg",
    "https://cdn.faire.com/fastly/99a8dbfd012f986682485b0ec282f10eef0f892914fd2d050d65ff42595728d7.jpeg",
  ],
  priceDollars: 9,
  description:
    "An evergreen style with broad gifting appeal. Customers paint the cards themselves and send them — no experience necessary, simple instructions included.\n\nIllustrations: bold mixed bouquet, chrysanthemums, lilacs, soft mixed bouquet.\n\n$9 wholesale · $18 retail · set of eight notecards + envelopes\n",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:11:12.601Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
